import { Panel } from "components/Panel/Panel";
import { TournamentLogo } from "components/Logo/TournamentLogo";
import { format } from "date-fns";
import { buildTournamentPath, buildTourPath } from "pages/PageConfigs";
import { FlexRow } from "styles/layout";
import {
  MetadataColumn,
  TournamentDate,
  TournamentDetails,
  TournamentLogoContainer,
  OptionContainer,
  TournamentStatusPill,
  TournamentStatusPillContainer,
} from "./styles";
import { TourLogo } from "components/Logo/TourLogo";
import { checkTypeExhausted } from "Utility";
import { TournamentStatus } from "model/Tournament/Tournament";

type OptionType = "Tour" | "Tournament";

interface Props {
  endTime: number;
  id: string;
  name: string;
  startTime: number;
  status: TournamentStatus;
  title: string;
  type: OptionType;
}

export const Option = ({
  endTime,
  id,
  name,
  startTime,
  status,
  title,
  type,
}: Props) => {
  const startDate = format(new Date(startTime), "dd MMM");
  const endDate = format(new Date(endTime), "dd MMM");
  const endDateYear = format(new Date(endTime), "dd MMM yyyy");
  const dateString =
    startDate === endDate ? endDateYear : `${startDate} - ${endDateYear}`;

  return (
    <Panel bottomMargin={false} navLink={getNavigatePath(type, id)}>
      <OptionContainer>
        <MetadataColumn>
          <FlexRow>
            <TournamentDetails>
              <span title={title}>{name}</span>
            </TournamentDetails>
          </FlexRow>
          <FlexRow>
            <TournamentStatusPillContainer>
              <TournamentStatusPill status={status}>
                {status}
              </TournamentStatusPill>
            </TournamentStatusPillContainer>
            <TournamentDate>{dateString}</TournamentDate>
          </FlexRow>
        </MetadataColumn>
        <TournamentLogoContainer>{getLogo(type, id)}</TournamentLogoContainer>
      </OptionContainer>
    </Panel>
  );
};

const getLogo = (type: OptionType, id: string) => {
  switch (type) {
    case "Tour":
      return <TourLogo id={id} />;
    case "Tournament":
      return <TournamentLogo id={id} />;
    default:
      return checkTypeExhausted(type);
  }
};

const getNavigatePath = (type: OptionType, id: string) => {
  switch (type) {
    case "Tour":
      return buildTourPath(id);
    case "Tournament":
      return buildTournamentPath(id);
    default:
      return checkTypeExhausted(type);
  }
};
